import { useState, useEffect } from "react";
import { ensureCatalogAuth } from "../../../services/backend/authService";
import { getBannersAll, activarBanner, eliminarBanner } from "../../../services/backend/bannerService";
import useActionState from "./useActionState";
import useDialogState from "./useDialogState";

const useBanners = ({ onError, canal }) => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [togglingId, setTogglingId] = useState(null);

    const editarDialog = useDialogState();
    const eliminarDialog = useDialogState();

    const { run: runDelete } = useActionState({
        onError,
    });

    const loadBanners = async () => {
        setLoading(true);
        try {
            await ensureCatalogAuth();
            const response = await getBannersAll({ canal });
            const data = Array.isArray(response?.banners) ? response.banners : Array.isArray(response) ? response : [];
            setBanners(data);
        } catch (err) {
            setBanners([]);
            onError?.(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadBanners();
    }, [canal]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleToggleEstado = async (banner) => {
        const id = banner.id || banner.codigo;
        setTogglingId(id);
        try {
            await activarBanner(id, !banner.activa);
            loadBanners();
        } catch (err) {
            onError?.(err);
        } finally {
            setTogglingId(null);
        }
    };

    const handleEliminar = async () => {
        const banner = eliminarDialog.selectedItem;
        if (!banner) return;
        const ok = await runDelete(async () => {
            await eliminarBanner(banner.id || banner.codigo);
        });
        if (ok) {
            eliminarDialog.close();
            loadBanners();
        }
    };

    const handleSave = () => {
        editarDialog.close();
        loadBanners();
    };

    return {
        banners,
        loading,
        togglingId,
        handleToggleEstado,
        editarDialog,
        eliminarDialog,
        handleEliminar,
        handleSave,
    };
};

export default useBanners;
